// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__1dIT9","footerMenu":"style_footerMenu__3_Wd9","socialIcon":"style_socialIcon__3k4zf"};